import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d205c53e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "rpp-edit" }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { class: "PaginationHolder" }
const _hoisted_4 = { class: "PaginationHolder" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_export_excel_modal = _resolveComponent("export-excel-modal")!
  const _component_rpp_mass_change_status = _resolveComponent("rpp-mass-change-status")!
  const _component_rpp_general_tabs = _resolveComponent("rpp-general-tabs")!
  const _component_page_title = _resolveComponent("page-title")!
  const _component_rpp_list_filters = _resolveComponent("rpp-list-filters")!
  const _component_failed_fetch = _resolveComponent("failed-fetch")!
  const _component_new_button = _resolveComponent("new-button")!
  const _component_new_limit = _resolveComponent("new-limit")!
  const _component_new_pagination = _resolveComponent("new-pagination")!
  const _component_rpp_list_item = _resolveComponent("rpp-list-item")!
  const _component_list = _resolveComponent("list")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.state.is_export)
      ? (_openBlock(), _createBlock(_component_export_excel_modal, {
          key: 0,
          onCancel: _cache[0] || (_cache[0] = ($event: any) => (_ctx.state.is_export = false))
        }))
      : _createCommentVNode("", true),
    (_ctx.mass_confirm_state.is_opened)
      ? (_openBlock(), _createBlock(_component_rpp_mass_change_status, {
          key: 1,
          title: _ctx.state.paymentBySupplierIds.length > 1 ? 'Массовое подтверждение' : 'Подтверждение',
          "payment-by-supplier-ids": _ctx.state.paymentBySupplierIds,
          onCancel: _ctx.onMassConfirmClose,
          onSuccess: _ctx.onMassConfirmSuccess
        }, null, 8, ["title", "payment-by-supplier-ids", "onCancel", "onSuccess"]))
      : _createCommentVNode("", true),
    (_ctx.mass_decline_state.is_opened)
      ? (_openBlock(), _createBlock(_component_rpp_mass_change_status, {
          key: 2,
          title: _ctx.state.paymentBySupplierIds.length > 1 ? 'Массовый отказ' : 'Отказ',
          "new-status": "denied",
          "payment-by-supplier-ids": _ctx.state.paymentBySupplierIds,
          onCancel: _ctx.onMassDeclineClose,
          onSuccess: _ctx.onMassDeclineSuccess
        }, null, 8, ["title", "payment-by-supplier-ids", "onCancel", "onSuccess"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", null, [
      _createVNode(_component_rpp_general_tabs, {
        value: "ftl",
        onExportData: _cache[1] || (_cache[1] = ($event: any) => (_ctx.state.is_export = true))
      }),
      _createVNode(_component_page_title, {
        title: "Список РПП FTL",
        class: "mt-6"
      }),
      _createVNode(_component_rpp_list_filters, {
        loading: _ctx.state.is_loading,
        onSearch: _ctx.onSearch,
        onReset: _ctx.onReset,
        class: "mt-3 mb-5"
      }, null, 8, ["loading", "onSearch", "onReset"]),
      (_ctx.data_state.rpp.is_failed && !_ctx.data_state.rpp.failure.error_state.is_cancel)
        ? (_openBlock(), _createBlock(_component_failed_fetch, {
            key: 0,
            loading: _ctx.data_state.rpp.is_loading,
            text: "При получении списка РПП произошла ошибка",
            "error-message": _ctx.data_state.rpp.failure.error_state.message,
            "error-url": _ctx.data_state.rpp.failure.error_state.url,
            "error-status": _ctx.data_state.rpp.failure.error_state.status,
            onRefresh: _cache[2] || (_cache[2] = ($event: any) => (_ctx.loadRPPList(_ctx.data_state.rpp.pagination.current_page)))
          }, null, 8, ["loading", "error-message", "error-url", "error-status"]))
        : (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_new_button, {
                class: "NewButton--30",
                disabled: _ctx.state.paymentBySupplierIds.length < 1,
                onClick: _ctx.onMassConfirm
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Массовое подтверждение ")
                ]),
                _: 1
              }, 8, ["disabled", "onClick"]),
              _createVNode(_component_new_button, {
                class: "NewButton--30 ml-6",
                disabled: _ctx.state.paymentBySupplierIds.length < 1,
                onClick: _ctx.onMassDecline
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Массовый отказ ")
                ]),
                _: 1
              }, 8, ["disabled", "onClick"]),
              _createVNode(_component_new_button, {
                class: "NewButton--30 ml-6",
                disabled: _ctx.state.is_loading,
                onClick: _ctx.selectAllPaymentBySupplierIds
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Выбрать все ")
                ]),
                _: 1
              }, 8, ["disabled", "onClick"]),
              _createVNode(_component_new_limit, {
                class: "ml-6",
                disabled: _ctx.data_state.rpp.is_loading,
                "total-items": _ctx.data_state.rpp.pagination.total_items,
                value: _ctx.filter_state.limit,
                onChange: _ctx.onLimitChange
              }, null, 8, ["disabled", "total-items", "value", "onChange"]),
              _createVNode(_component_new_pagination, {
                class: "ml-6",
                disabled: _ctx.data_state.rpp.is_loading,
                "current-page": _ctx.data_state.rpp.pagination.current_page,
                "total-pages": _ctx.data_state.rpp.pagination.total_pages,
                onChangePage: _ctx.onChangePage
              }, null, 8, ["disabled", "current-page", "total-pages", "onChangePage"])
            ]),
            _createVNode(_component_list, {
              loading: _ctx.state.is_loading,
              items: _ctx.data_state.rpp.list
            }, {
              item: _withCtx(({ item }) => [
                _createVNode(_component_rpp_list_item, {
                  item: item,
                  "is-selected": _ctx.state.paymentBySupplierIds.includes(item.id),
                  onChanged: _ctx.onChangeCompany,
                  onDeleted: _ctx.onRppDeleted,
                  onSubmit: _ctx.loadRPPList,
                  onSelect: _ctx.selectPaymentBySupplierId,
                  onUnselect: _ctx.unselectPaymentBySupplierId,
                  onConfirm: _ctx.onConfirmItem
                }, null, 8, ["item", "is-selected", "onChanged", "onDeleted", "onSubmit", "onSelect", "onUnselect", "onConfirm"])
              ]),
              _: 1
            }, 8, ["loading", "items"]),
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_new_limit, {
                disabled: _ctx.data_state.rpp.is_loading,
                "total-items": _ctx.data_state.rpp.pagination.total_items,
                value: _ctx.filter_state.limit,
                onChange: _ctx.onLimitChange
              }, null, 8, ["disabled", "total-items", "value", "onChange"]),
              _createVNode(_component_new_pagination, {
                class: "ml-6",
                disabled: _ctx.data_state.rpp.is_loading,
                "current-page": _ctx.data_state.rpp.pagination.current_page,
                "total-pages": _ctx.data_state.rpp.pagination.total_pages,
                onChangePage: _ctx.onChangePage
              }, null, 8, ["disabled", "current-page", "total-pages", "onChangePage"])
            ])
          ]))
    ])
  ]))
}